
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import { get_token,get_user_details ,set_user_details} from "@/router";
import Swal from "sweetalert2";
import { ref } from "vue";
const domain = window.location.hostname;

export default {
  components: {
    HomeNavBar,
  },

  mounted() {
    this.user.user_id = this.$route.query.user_id
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.fetch_races();
    this.fetch_gender();
    this.fetch_title();
    this.fetch_province();
    this.get_rating();
    this.get_profile();



    this.filter_membership_payment_history();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    this.fetchProfiles();

    if(domain.includes('workbook')) {
      this.workbook_domain = true;
    }



    if (this.user_details.user_id===this.user.user_id) {
      this.user.first_name = this.user_details.first_name || '';
      this.user.last_name = this.user_details.last_name || '';
      this.user.email =this.user_details.email || '';
      this.user.phone_number =this.user_details.phone_number || '';
      
    }
  },
  data() {
    return ({
    user: this.getUserData(),
      races: [],race_id: '',
      genders: [],
      titles: [],title_id: '',
      cv: null,
      cv_url: null,
      skills : [],
      work_experiences: [],
      educations: [],
      fileType: '',
      isLocalFile: false,
      local_file_url:null,
      address:this.get_address(),
      rating: 0,
      totalRatings: 0,
      profileData:[],
      user_details: {
        "user_role": '',
      },
      token_exists: true,
      isLoading: false,
      profile: {},
      errors: {},
      showPreview: false,
      file_name: '',
      membership_payment_history_id: null,
      membership_payment_history: [],
      membership_name:'',
      membership_type:'',
      membership_price:0,
      userHasPaid: false,
      billing_cycle:'',
      type_of_profile: [],
      base_profiles: [],
      displayLetter: '',
      profile_questions: [],
      workbook_domain: false,
      renewal_date: null,
      is_active: false,

    });
  },
  setup() {
    const subscriptionExpanded = ref(false);
    const showManagement = ref(false);

    return { subscriptionExpanded, showManagement };
  },
  methods: {

    getUserData() {
        let user={ first_name: '',
            last_name: '',
            email: '',
            gender_id: '',
            date_of_birth: '',
            phone_number: '',
            user_id: '',
            newSkill: '' }
        return user;
    },
    get_address() {
        let address = {
            street_address: '',
            town: '',
            postal_code: '',
            province_id: '',
            }
      return address
    },
    get_profile() {
        this.isLoading = true;
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile/`,
          type: 'GET',
          headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
          },
          data: {
            user_id: this.user.user_id
          },
          success: (data) => {
            if (data.status === 'success' && data.data.profile_data.user) {
                this.profileData = data.data.profile_data;
                this.user.date_of_birth = this.profileData.date_of_birth || '';
                this.address.street_address = this.profileData.street_address || '';
                this.address.town = (this.profileData.town || '').charAt(0).toUpperCase() + (this.profileData.town || '').slice(1).toLowerCase();
                this.address.postal_code = this.profileData.postal_code || '';
                this.skills = this.profileData.user_skills.map(item => item.skill.name);
                this.work_experiences = this.profileData.user_experience.map(item => ({
                  company_name: item.experience.company_name,
                  job_title: item.experience.job_title,
                  start_date: item.experience.start_date,
                  end_date: item.experience.end_date,
                  description: item.experience.description,
                }));
                this.educations = this.profileData.user_education.map(item => ({
                  institution_name: item.education.institution_name,
                  degree: item.education.degree,
                  field_of_study: item.education.field_of_study,
                  start_date: item.education.start_date,
                  end_date: item.education.end_date,
                }));


              if (this.profileData.profile_files && this.profileData.profile_files.length > 0) {
                this.cv_url = this.profileData.profile_files[0].file.file_url;
                this.cv = this.profileData.profile_files[0].file;
                this.file_name = this.profileData.profile_files[0].file.name;
              } else {
                this.cv = null;
              }

              for (const race of this.races) {
                if (race.race === this.profileData.race) {
                  this.race_id = race.id;
                  break;
                }
              }

              // Match Gender
              for (const gender of this.genders) {
                if (gender.gender === this.profileData.gender) {
                  this.user.gender_id = gender.id;
                  break;
                }
              }

              // Match Province
              for (const province of this.provinces) {
                if (province.province_name === this.profileData.province) {
                  this.address.province_id = province.id;
                  this.province_name = province.province_name;
                  break;
                }
              }

              // Match Title
              for (const title of this.titles) {
                if (title.title === this.profileData.title) {
                  this.title_id = title.id;
                  break;
                }
              }
            }
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },

    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {

        this.user.user_id = this.user_details.user_id;
      }

      const payload = {
        filter_values: {
          user_id: this.user.user_id,

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {"Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "paid"
          );

          this.is_active = this.membership_payment_history[0]?.is_active || false;
          this.membership_payment_history_id = this.membership_payment_history[0]?.id || null;
          this.membership_name =this.membership_payment_history[0]?.membership?.name || '';
          this.membership_type = this.membership_payment_history[0]?.membership?.membership_type.name || '';
          this.billing_cycle = this.membership_payment_history[0]?.membership?.billing_cycle?.name || '';
          this.membership_price = this.membership_payment_history[0]?.membership?.membership_pricing[0]?.price || 0;
          this.renewal_date = this.membership_payment_history[0]?.valid_until|| null;
        },
        complete: () => {
          this.isLoading = false;
        },
      })
    },

    cancel_membership() {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, cancel it!'
      }).then((result) => {
        if (result.isConfirmed) {
$.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/cancel_membership/`,
        method: "POST",
        data: JSON.stringify({ membership_id: this.membership_payment_history_id }),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {"Content-Type": "application/json" },
        success: (response) => {
          if( response.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Membership cancelled successfully',
            })
            this.showManagement = false;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      })
      }
      })
    },

    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle('close');
    },

    toggleCheckbox(qa, optionId, isChecked) {
      if (!qa.newAnswer) {
        // Initialize newAnswer with the current answer if it exists
        qa.newAnswer = Array.isArray(qa.answer) ? qa.answer.slice() : qa.answer ? qa.answer.split(',').map(opt => opt.trim()) : [];
      }

      if (isChecked) {
        // Add the option if it's not already in the array
        if (!qa.newAnswer.includes(optionId)) {
          qa.newAnswer.push(optionId);
        }
      } else {
        // Remove the option if it exists in the array
        const index = qa.newAnswer.indexOf(optionId);
        if (index > -1) {
          qa.newAnswer.splice(index, 1);
        }
      }
    },

    get_rating() {
      if (!this.user_id) {
      
        this.user_id = this.user_details.user_id;
      }
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_profile_rating/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: {
          user_id: this.user_id
        },
        success: (response) => {
          if (response.status === 'success') {
            this.rating = response.data.average_rating;
            this.totalRatings= response.data.total_count

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    saveRating(ratingValue) {
      this.rating = ratingValue;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_profile_rating/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ user_id: this.user_id, rating: this.rating }),
        success: (response) => {
          if (response.status === "success") {
            this.rating = response.data.average_rating;
            this.totalRatings= response.data.total_count
          }
        },
      });
    },

    handle_file_upload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (this.validateFile(file)) {
          this.cv = file;
          this.file_name = file.name;
          this.fileType = file.type;
          this.local_file_url = URL.createObjectURL(file);
          this.isLocalFile = true;
          this.showPreview = true;
          this.errorMessage = '';  // Clear error message
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Invalid File Type',
            text: 'Only PDF and Word documents are allowed.',
          });
          this.resetFileUpload();
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'No File Selected',
          text: 'Please select a file to upload.',
        });
        this.resetFileUpload();
      }
    },
    validateFile(file) {
      const allowedTypes = ['application/pdf', 'application/msword'];

      if(allowedTypes.includes(file.type)) {
        return true;
      } else {
        return false;
      }
    },

    resetFileUpload() {
      // Reset the file upload fields
      this.cv = null;
      this.local_file_url = null;
      this.fileType = '';
      this.file_name = '';
      this.isLocalFile = false;
      this.showPreview = false;
      this.errorMessage = '';  // Reset error message
    },
    validationProfileForm() {
      this.errors = {};
      let valid = true;

      if (this.first_name === '') {
        this.errors.first_name = 'First name is required';
        valid = false;
      }

      if (this.last_name === '') {
        this.errors.last_name = 'Last name is required';
        valid = false;
      }

      if (this.date_of_birth === '') {
        this.errors.date_of_birth = 'Date of birth is required';
        valid = false;
      }
      if (this.race_id === '') {
        this.errors.race_id = 'Race is required';
        valid = false;
      }
      if (this.gender_id === '') {
        this.errors.gender_id = 'Gender is required';
        valid = false;
      }
      if (this.title_id === '') {
        this.errors.title_id = 'Title is required';
        valid = false;
      }
      if (this.address.street_address === '') {
        this.errors.street_address = 'Street address is required';
        valid = false;
      }
      if (this.address.town === '') {
        this.errors.town = 'Town is required';
        valid = false;
      }
      if (this.address.postal_code === '') {
        this.errors.postal_code = 'Postal code is required';
        valid = false;
      }
      if (this.address.province_id === '') {
        this.errors.province_id = 'Province is required';
        valid = false;
      }

      return valid;
    },

    getOptionValue(answerId, options) {

      if (!options || !Array.isArray(options)) {
        return null; // Return null if options is not an array
      }

      const normalizedAnswerIds = Array.isArray(answerId)
        ? answerId.map(id => (typeof id === 'string' ? parseInt(id, 10) : id))
        : [typeof answerId === 'string' ? parseInt(answerId, 10) : answerId];

      // Filter options to find all matches
      const matchedOptions = options.filter(opt => normalizedAnswerIds.includes(opt.id));

      // If answerId is an array (checkboxes), return all matched options' values
      if (Array.isArray(answerId)) {
        return matchedOptions.map(opt => opt.option);
      }
      return matchedOptions.length > 0 ? matchedOptions[0].option : null;
    },

    saveProfile() {

      if (!this.validationProfileForm()) {
        return;
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we create the profile.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.isLoading = true;
      const formData = new FormData();

      formData.append('first_name', this.user.first_name);
      formData.append('last_name', this.user.last_name);
      formData.append('date_of_birth', this.user.date_of_birth);
      formData.append('gender_id', this.user.gender_id);
      formData.append('race_id', this.race_id);
      formData.append('title_id', this.title_id);
      formData.append('phone_number', this.user.phone_number);
      formData.append('street_address', this.address.street_address);
      formData.append('town', this.address.town);
      formData.append('postal_code', this.address.postal_code);
      formData.append('province_id', this.address.province_id);
      const answeredQuestions = this.profile_questions
          .filter(question => question.answer !== undefined && question.answer !== null)
          .map(question => ({
            question_id: question.question.id,
            // Convert checkbox answers to a comma-separated string
            answer: Array.isArray(question.answer) ? question.answer.join(', ') : question.answer
          }));
        formData.append('answers', JSON.stringify(answeredQuestions));
        formData.append('base_profile',this.profileData.base_profile.id );

      if (this.cv) {
        if (this.cv instanceof File) {
          formData.append('file', this.cv);
        }
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_user_profile/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (body) => {
          if (body.status === 'success') {

            this.fetch_races();
            this.fetch_gender();
            this.fetch_title();
            this.fetch_province();


            Swal.fire({
              title: 'Success',
              text: 'Profile Created Successfully',
              icon: 'success',
              timer: 1000,
              showConfirmButton: false,
            }).then(() => {
              window.location.reload();
            });
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });

    this.isLoading = true;


    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/update_user_profile/`,
      type: 'POST',
      headers: {
        Authorization: `Token ${get_token()}`,
      },
      data: formData,
      processData: false,
      contentType: false,


      success: (data) => {
        if (data.status === 'success') {
            this.appendProfileInfo(data.data); // Dynamically append the updated profile info
            this.fetch_races();
            this.fetch_gender();
            this.fetch_title();
            this.fetch_province();
    
            Swal.fire({
                title: 'Success',
                text: 'Profile Updated Successfully',
                icon: 'success',
                timer: 1000,
                showConfirmButton: false,
            }).then(() => {
              $('#profile_modal').modal('hide');
          });
        }
    },
      complete: () => {
        this.isLoading = false;

      },
    })


    },

    appendProfileInfo(profileData) {
      // Dynamically update the UI with the saved profile information
      this.user.first_name = profileData.first_name;
      this.user.last_name = profileData.last_name;
      this.user.date_of_birth = profileData.date_of_birth;
      this.address.street_address = profileData.street_address;
      this.address.town = profileData.town;
      this.address.postal_code = profileData.postal_code;
      this.address.province_id = profileData.province_id;
      this.skills = profileData.skills || [];
      this.work_experiences = profileData.work_experiences || [];
      this.educations = profileData.educations || [];
      this.cv_url = profileData.cv_url || null;
      this.file_name = profileData.file_name || '';
  },

  submitAnswer(qa) {
  
        const base_profile_id = this.profileData?.base_profile?.id;
  
        // Combine the newAnswer array with the existing answer if needed
        const combinedAnswers = qa.newAnswer || qa.answer;
        const filteredAnswers = Array.isArray(combinedAnswers)
          ? combinedAnswers.filter((value, index, self) => value && self.indexOf(value) === index) // Remove duplicates and empty values
          : combinedAnswers;
  
        const answer = Array.isArray(filteredAnswers)
          ? filteredAnswers.join(",") // Join array values into a comma-separated string
          : filteredAnswers;
  
        // Prepare the payload
        const payload = {
          base_profile_id: base_profile_id,
          answers: [
            {
              question_id: qa.question.id,
              answer: answer,
            },
          ],
        };
  
        // Send the AJAX request
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/answer_questions_for_base_profile/`,
          type: "POST",
          headers: {
            Authorization: `Token ${get_token()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(payload),
          success: (response) => {
            if (response.status === "success") {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Answer submitted successfully.",
                showConfirmButton:false,
                timer:2000
              });
              qa.answer = answer;
              qa.isEditing = false; // Close the editing mode
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "An error occurred.",
              });
            }
          },
        });
      },

    previewDocument() {
      if(this.cv_url) {
        this.showPreview = true;
        this.isLocalFile = false;
      }
    },
    closeModal() {
      this.showPreview = false;
      URL.revokeObjectURL(this.cvUrl); 
      this.cv_url = '';
    },
    fetch_races() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_races/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.races = response.data.race_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_gender() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_genders/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.genders = response.data.gender_data;

            

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_title() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_titles/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.titles = response.data.title_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    fetch_province() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_provinces/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.provinces = response.data.province_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    addSkill() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('skills_name', this.newSkill);

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/add_skills_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {

          this.$emit('addSkill',response.message)
          Swal.close();

          Swal.fire({
            icon: 'success',
            title: 'Skill Added',
            showConfirmButton: false,
            timer: 1000
          }).then(() => {
            this.skills.push(this.newSkill);
            this.newSkill = '';
            $('#addSkillModal').modal('hide');
            Swal.close();
            this.isDropdownVisible = false;
          });
        },
        error: (response) => {
          const response_data=response.responseJSON
          Swal.close();
          if(response_data.status==="error"){
            this.errors.newSkill=response_data.message
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },


    fetch_type_of_organization() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    update_answer(questionId, value) {
      // Find the question object by its ID
      const question = this.profile_questions.find(q => q.question.id === questionId);
      
      // Update the answer for the question
      if (question) {
        question.answer = value; // Update with the selected value
      }
    },
  
    // Handle checkbox answers (multiple selections allowed)
    toggle_checkbox_answer(questionId, option, isChecked) {
      const question = this.profile_questions.find(q => q.question.id === questionId);
      
      if (question) {
        // Initialize the answer as an empty array if it's undefined
        if (!Array.isArray(question.answer)) {
          question.answer = [];
        }
        
        // If the checkbox is checked, add the option to the answer
        if (isChecked) {
          question.answer.push(option);
        } else {
          // Otherwise, remove it from the answer
          const index = question.answer.indexOf(option);
          if (index !== -1) {
            question.answer.splice(index, 1);
          }
        }
      }
    },

  fetchProfiles() {
    this.isLoading = true;

    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
        type: 'GET',
        headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
        },
        success: (response) => {
            if (response.status === 'success' && response.data.profiles) {
                this.base_profiles = response.data.profiles;
            }
        },
        complete: () => {
            this.isLoading = false;
        }
    });
},
fetch_type_of_profile() {
  this.isLoading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
    type: 'GET',
    headers: {
      Authorization: `Token ${get_token()}`,
      'Content-Type': 'application/json',
    },
    success: (response) => {
      if (response.status === 'success') {
        this.type_of_profile = response.data.type_of_profile_data;

        this.show_questions()

      }
    },
    complete: () => {
      this.isLoading = false;
    },
  });
},

show_questions() {

  const personal_profile = this.type_of_profile.find(
    (profile) => profile.name.toLowerCase() === 'personal'
  );
  const payload = {
    filter_values: {
      profile_type_id:  personal_profile.id,
    },
  };
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
    type: "POST",
    headers: {
      Authorization: `Token ${get_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
    success: (response) => {
      this.profile_questions = (response.data || []).map(q => {
  return {
    ...q,
    form_section: {
      ...(q.form_section || {}),
      section: q.form_section?.section || { name: '' }, // ensure section exists
    },
    question: q.question || {}, // question might still be null, guard it
  };
});

    },
  });
}
  },
};